import { Note } from '@phosphor-icons/react';

export default Note;
